
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publisher-application",
      function () {
        return require("private-next-pages/publisher-application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publisher-application"])
      });
    }
  